import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./ProductPricingForm";
import {GET_CURRENT_SHOP_SUBSCRIPTION_PRODUCT_PRICING} from "../../../queries/inventory";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelChangeSubscriptionProductPricing} from "../../../actions/InventoryApiActions";
import {fromJS, Map, List} from "immutable";
import {validateGreaterThan} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

function transformInput(values) {
  let pricing = values.get("pricing", Map()).reduce((acc, val, key) => {
    return acc.push({
      currency: key,
      value: val
    })
  }, List());
  return values.set("pricing", pricing);
}

class ChangeSubscriptionProductPricingFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    // The data has to be translated to be sent out.
    let transValues = transformInput(values)
                          .set("shopId", this.props.shopId)
                          .set("productSku", this.props.productId);
    return this.props.changeSubscriptionPricing(transValues.toJS())
      .then((response) => {
        if (response.data.changeSubscriptionPricing.errors.length <= 0) {
          this.props.cancelChangeSubscriptionProductPricing();
        } else {
          let errors = createValidationErrors(response.data.changeSubscriptionPricing.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelChangeSubscriptionProductPricing();
  }

  validateForm(values) {
    let errors = Map();
    let currencyErrors = values.get("pricing", Map()).reduce((acc, value, currency) => {
      return validateGreaterThan(acc, values.get("pricing", Map()), currency, 0);
    }, Map());
    // Merge into errors when present.
    if (currencyErrors.size > 0) {
      errors = errors.set("pricing", currencyErrors);
    }
    return errors.toJS();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let shopProduct = fromJS(data.shopSubscriptionProductCurrentPricelist);
    let initialValues = shopProduct.get("pricing").reduce((acc, x) => {
      return acc.setIn(["pricing", x.get("currency")], x.get("value"));
    }, fromJS({pricing: {}}));
    return (
      <Form
        initialValues={initialValues.toJS()}
        pricing={shopProduct.get("pricing")}
        errors={this.state.errors}
        validate={this.validateForm.bind(this)}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const CHANGE_SUBSCRIPTION_PRICING = gql`
  mutation changeSubscriptionPricing($data: ProductToShopInput!) {
    changeSubscriptionPricing(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(GET_CURRENT_SHOP_SUBSCRIPTION_PRODUCT_PRICING, {
    options: (props) => ({
      variables: {
        shopId: props.shopId,
        productSku: props.productId
      }
    })
  }),
  graphql(CHANGE_SUBSCRIPTION_PRICING, {
    props: ({ mutate }) => ({
      changeSubscriptionPricing: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const ChangeSubscriptionProductPricingFormContainerWithData = withProductQuery(ChangeSubscriptionProductPricingFormContainer);

export default connect(null, {cancelChangeSubscriptionProductPricing})(ChangeSubscriptionProductPricingFormContainerWithData);